(function () {
  function initSlider(el, section) {
    el.setAttribute('data-et-bp-init', '');

    var options = {
      slidesPerView: parseFloat(el.dataset.slidesMobile) || 1.1,
      spaceBetween: 12,
      breakpoints: {
        750: { slidesPerView: 2, spaceBetween: 16 },
        990: { slidesPerView: parseFloat(el.dataset.slidesDesktop) || 3, spaceBetween: 16 }
      }
    };

    var prev = section.querySelector('.et-bp__arrow--prev');
    var next = section.querySelector('.et-bp__arrow--next');
    if (prev && next) {
      options.navigation = { prevEl: prev, nextEl: next };
    }

    var dots = section.querySelector('.et-bp__dots');
    if (dots) {
      options.pagination = { el: dots, clickable: true };
    }

    new Swiper(el, options);
  }

  function initSection(section) {
    var el = section.querySelector('.et-bp__swiper:not([data-et-bp-init])');
    if (!el) return;
    whenSwiperReady(function () {
      initSlider(el, section);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.et-bp').forEach(initSection);
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList && event.target.classList.contains('et-bp')) {
      initSection(event.target);
    } else if (event.target.querySelector('.et-bp')) {
      initAll(event.target);
    }
  });
})();
